import { useLang } from "hooks/useLang"
import Image from "next/image"
import Link from "next/link"
import React from "react"
import { IFinalEvent } from "types/event"

interface IProps {
    event: IFinalEvent
}

const EventLocation = ({ event }: IProps) => {
    const { isAr } = useLang()

    return (
        <div className="flex flex-col gap-y-3 mt-2 max-w-2xl">
            <div className="col map mt-1">
                <Link
                    target="_blank"
                    href={`https://maps.google.com/?q=${event?.address?.location?.lat},${event?.address?.location?.long}`}
                >
                    <Image
                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${event?.address?.location?.lat},${event?.address?.location?.long}&zoom=16&scale=2&size=600x300&maptype=roadmap&format=png&key=${process.env.NEXT_PUBLIC_GOOGLE_STATIC_MAPS_API_KEY}&markers=size:mid%7Ccolor:0xF00%7C${event?.address?.location?.lat},${event?.address?.location?.long}&language=${isAr ? "ar" : "en"}`}
                        height={150}
                        width={1500}
                        alt="map_image"
                        style={{ borderRadius: 5 }}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        priority={true}
                        loading="eager"
                    />
                </Link>
            </div>
        </div>
    )
}

export default EventLocation
